import List from '@/pages/admin/services/List.vue';
import Show from '@/pages/admin/services/Show.vue';
import handleActivePaginationRouteProps from '@/utils/handleActivePaginationRouteProps.js';

export default [
  {
    path: 'services',
    name: 'services',
    component: List,
    props: handleActivePaginationRouteProps,
  },
  {
    path: 'services/:id(\\d+)',
    name: 'service',
    component: Show,
  },
];
